export default {
  init() {

  },
  finalize() {
    /**
     * Events
     */
    if ($('.product-type-booking').length > 0) {

      // Breadcrumb alteration
      $('.woocommerce-breadcrumb').find('a:first-of-type').attr('href', $('section.single-event').data('events-home'));
      $('.woocommerce-breadcrumb').find('a:first-of-type').html($('section.single-event').data('events-home-text'));
      $('.woocommerce-breadcrumb').find('a:nth-of-type(2)').remove();
      $('.woocommerce-breadcrumb').html($('.woocommerce-breadcrumb').html().replace('&nbsp;/&nbsp;', ''));

      // Gallery carousel
      const $eventGalleryCarousel = $('.event-gallery-carousel');
      if ($eventGalleryCarousel.length > 0) {
        $eventGalleryCarousel.owlCarousel({
          dots: false,
          items: 1,
          loop: true,
          autoplay: false,
        });
      }
    }

  },
}



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js